<template>
  <div>
    <buscar-producto @seleccionado="onSeleccionado" />

    <modal :name="modalName" width="95%" height="95%">
      <div class="modal-contenido">
        <div class="modal-cuerpo">
          <div v-if="producto && Object.keys(producto).length > 0" class="detalles-producto">
            <h1 class="nombre-producto">{{ producto.nombre }}</h1>
            <p class="codigo-producto">Código: {{ producto.codigo }}</p>
            <h1 class="precio-producto">${{ parseInt(producto.precioVenta).toLocaleString("es-CO") }}</h1>
          </div>
          <div v-else class="no-encontrado">
            <h2>No se ha encontrado producto</h2>
          </div>
        </div>
      </div>

      <!-- 🔥 Barra de carga debajo -->
      <div class="barra-carga">
        <div class="progreso" :style="{ width: barraWidth + '%' }"></div>
      </div>
      <p class="texto-carga">Recargando en {{ tiempoRestante }} segundos...</p>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import BuscarProducto from "../Inventario/BuscarProducto.vue";
import VModal from "vue-js-modal";
import Utiles from "../../Servicios/Utiles";

Vue.use(VModal);

export default {
  components: {
    BuscarProducto,
  },
  data() {
    return {
      producto: null,
      modalName: "info-modal",
      urlImagen: null,
      tiempoRestante: 10, // Siempre empieza en 10 segundos
      barraWidth: 100, // La barra comienza llena
      intervalo: null,
    };
  },
  methods: {
    iniciarAutoRecarga() {
      // Reiniciamos los valores
      this.tiempoRestante = 10;
      this.barraWidth = 100;

      // Si ya había un intervalo, lo eliminamos para reiniciarlo
      if (this.intervalo) clearInterval(this.intervalo);

      let startTime = Date.now();
      let duration = this.tiempoRestante * 1000; // Convertimos a milisegundos

      const animarBarra = () => {
        let tiempoPasado = Date.now() - startTime;
        let progreso = Math.max(100 - (tiempoPasado / duration) * 100, 0);

        this.barraWidth = progreso;

        if (progreso > 0) {
          requestAnimationFrame(animarBarra);
        } else {
          window.location.reload();
        }
      };

      this.intervalo = setInterval(() => {
        if (this.tiempoRestante > 1) {
          this.tiempoRestante--;
        } else {
          clearInterval(this.intervalo);
        }
      }, 1000);

      requestAnimationFrame(animarBarra);
    },

    onSeleccionado(producto) {
      if (!producto || Object.keys(producto).length === 0) {
        this.producto = null;
        return;
      }
      this.producto = producto;
      this.urlImagen = producto.imagen
        ? Utiles.regresarRuta() + producto.imagen
        : null;

      this.mostrarInformacionProducto();
    },

    mostrarInformacionProducto() {
      this.$modal.show("info-modal");
      this.iniciarAutoRecarga(); // 🔥 Reiniciar el temporizador al mostrar el producto
    },
  },
};
</script>

<style scoped>
.modal-contenido {
  background: #fff;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  height: 100%;
}

.modal-cuerpo {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
}

.detalles-producto {
  width: 100%;
  text-align: center;
}

.nombre-producto {
  font-size: calc(3vw + 1em);
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  word-wrap: break-word;
}

.codigo-producto {
  font-size: calc(2vw + 0.5em);
  color: #666;
  margin-bottom: 20px;
  word-wrap: break-word;
}

.precio-producto {
  font-size: calc(4vw + 1em);
  font-weight: bold;
  color: #27ae60;
  margin-bottom: 30px;
  word-wrap: break-word;
}

/* 🔥 Barra de carga en la parte inferior */
.barra-carga {
  width: 100%;
  height: 5px;
  background-color: #ddd;
  border-radius: 5px;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
}

.progreso {
  height: 100%;
  background-color: #27ae60;
  transition: width 0.1s linear;
}

.texto-carga {
  text-align: center;
  font-size: 14px;
  color: #555;
  position: fixed;
  bottom: 10px;
  width: 100%;
}
</style>
